import React from 'react';
import { Link } from 'react-router-dom';
import { ButtonBox, FixedButton } from './styles';

function LargeFixedButton(props) {
  const { directTo, buttonName, onClick } = props;

  return (
    <ButtonBox>
      {!onClick ?
        <FixedButton
          variant="contained"
          color="secondary"
          fullWidth
          to={directTo}
          component={Link}
        >
          {buttonName}
        </FixedButton> :
        <FixedButton
          variant="contained"
          color="secondary"
          fullWidth
          onClick={onClick}
        >
          {buttonName}
        </FixedButton>}
    </ButtonBox>
  );
}

export default LargeFixedButton;
